// extracted by mini-css-extract-plugin
export default {"writeBar":"ChatDialogsPage_writeBar__DBaua","filePreview":"ChatDialogsPage_filePreview__bpRnm","chip":"ChatDialogsPage_chip__TsJsS"};